/* eslint-disable */
import { type ReactNode } from 'react'
import { WarningCircle, CheckCircle, X, Info } from 'phosphor-react'
import clsx from 'clsx'

interface AlertProps {
  children: ReactNode
  fullWidth?: boolean
  variant: keyof typeof icons
  onClose?: () => void
}

const icons = {
  success: CheckCircle,
  error: WarningCircle,
  info: Info,
}

export const Alert = ({
  variant,
  children,
  fullWidth = false,
  onClose,
}: AlertProps) => {
  const Icon = icons[variant]

  return (
    <div
      className={clsx(
        'relative h-fit py-2 px-4 rounded-tr rounded-br overflow-hidden flex items-center  before:block before:w-1 before:h-full before:rounded-[0px_4px_4px_0px] before:mr-3 before:absolute before:left-0',
        {
          'bg-[#FFE7E7] before:bg-alert-error': variant === 'error',
          'bg-[#E0FAE2] before:bg-alert-success': variant === 'success',
          'bg-[#E0FFFF] before:bg-secondary-light': variant === 'info',
          'w-full': fullWidth === true,
          'w-80 md:w-96': fullWidth === false,
        }
      )}
    >
      <Icon
        className={clsx(
          'text-2xl mr-3',
          variant === 'error' && 'text-alert-error',
          variant === 'success' && 'text-alert-success',
          variant === 'info' && 'text-secondary-light'
        )}
      />
      <p className="flex-1 text-xs text-grey-800 font-medium md:text-base">
        {children}
      </p>
      {onClose && (
        <button className="ml-8" type="button" onClick={onClose}>
          <X className="text-xl text-grey-800" />
        </button>
      )}
    </div>
  )
}
